<template>
    <div class="uk-margin-xsmall-top">
        <label class="uk-cursor-pointer"
               :class="{ checked: isChecked }">
            <input class="uk-checkbox uk-margin-xsmall-right"
                   type="checkbox"
                   :checked="isChecked"
                   @change.stop="setValue"
            > {{ filterItem.label }}
        </label>
    </div>
</template>


<script>
    import { mapGetters } from "vuex";
    
    export default {
        name: "dr-checkbox",
        props: [
            'filterItem', 'filterIndex', 'itemIndex', 'filterId', 'filterItemKey'
        ],
        mounted() {
        },
        computed: {
            ...mapGetters([
                'activeFilters'
            ]),
            isChecked() {
                // Check if this filter is active (case-insensitive)
                if (this.activeFilters[this.filterIndex] && this.activeFilters[this.filterIndex].length) {
                    return this.activeFilters[this.filterIndex].some(activeFilter => 
                        activeFilter.toLowerCase() === this.filterItem.label.toLowerCase()
                    );
                }
                return false;
            }
        },
        methods: {
            setValue(e) {
                if (e.target.checked) {
                    this.$store.dispatch('setActiveFilter', {
                        filterCategory: this.filterIndex,
                        filterIndex: this.itemIndex
                    });
                } else {
                    this.$store.dispatch('removeActiveFilter', {
                        filterCategory: this.filterIndex,
                        filterIndex: this.itemIndex
                    });
                }
            }
        }
    }
</script>

<style lang="scss">
    .uk-cursor-pointer {
        color: #a2a2a2;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 1.26;
        letter-spacing: -.28px;
        transition: all .15s ease-in-out;

        &:hover {
            text-decoration: none;
            background-color: transparent;
            color: #6c6a6b;
        }

        &.checked {
            background-color: transparent;
            color: #0b0b0b;
        }
    }

    .uk-checkbox {
        margin-bottom: 0;
        position: relative;
        padding-left: 15px;
        display: inline-block;
        width: auto;
        box-sizing: border-box;
        text-align: left;
        border: none !important;
        height: 15px !important;
        border-radius: 0;

        &:checked {
            background-image: none !important;
        }

        &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 15px; // Checkbox size
        height: 15px;
        border-radius: 2px;
        border: 1px solid #a2a2a2;
        background: transparent; // Default background
        box-sizing: border-box;
        }

        &::after {
        content: "";
        position: absolute;
        left: 4px;
        top: 50%;
        transform: translateY(-50%);
        width: 7px;
        height: 7px;
        border-radius: 1px;
        background: transparent;
        }

        &:checked::after {
        background: #a6b0ff; // Fill the checkbox when active
        }
    }
</style>

